import { createContext, useContext } from "react";
import { Language } from "models/enums/languages";

export interface PublicLayoutContextValue {
  /** True while a page is rendered inside the public (logged out) layout. */
  isInPublicLayout: boolean;
  /** Language selected in the public layout's language picker. */
  language: string;
}

export const publicLayoutDefaultValue: PublicLayoutContextValue = {
  isInPublicLayout: false,
  language: Language.ENGLISH,
};

const PublicLayoutContext = createContext<PublicLayoutContextValue>(publicLayoutDefaultValue);

export const usePublicLayout = () => useContext(PublicLayoutContext);

export default PublicLayoutContext;
